import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { StatusDialogState } from "@/types/loads";

interface LoadStatusDialogProps {
  dialog: StatusDialogState | null;
  statusReason: string;
  onStatusReasonChange: (value: string) => void;
  onClose: () => void;
  onConfirm: () => void;
}

export function LoadStatusDialog({
  dialog,
  statusReason,
  onStatusReasonChange,
  onClose,
  onConfirm,
}: LoadStatusDialogProps) {
  return (
    <Dialog 
      open={dialog?.open ?? false} 
      onOpenChange={(open) => !open && onClose()}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {dialog?.status === "partial" ? "Osittain valmis" : "Ohitettu"}
          </DialogTitle>
          <DialogDescription>
            {dialog?.status === "partial"
              ? "Miksi tehtävä jäi osittaiseksi?"
              : "Miksi tehtävä ohitettiin?"}
          </DialogDescription>
        </DialogHeader>
        <Textarea
          placeholder="Kirjoita syy..."
          value={statusReason}
          onChange={(e) => onStatusReasonChange(e.target.value)}
        />
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Peruuta
          </Button>
          <Button onClick={onConfirm}>
            Tallenna
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
